/*
 *
 * ReportExport actions
 *
 */

import {
  GET_EXPORT_REPORT_WATCHER,
  GET_MEDITIONS_REPORT_EXPORT_SUCCESS,
  GET_MEDITIONS_REPORT_EXPORT_WATCHER,
  GET_EXPORT_REPORT_SUCCESS,
  GET_EXPORT_REPORT_FAILED,
  GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_SUCCESS,
  GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_WATCHER,
} from "./constants"

// list to export
export function getMeditionsReportExportWatcher(payload) {
  return {
    type: GET_MEDITIONS_REPORT_EXPORT_WATCHER,
    payload,
  }
}

export function getDivisionsAmbassadorReportExportSuccess(payload) {
  return {
    type: GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_SUCCESS,
    payload,
  }
}

export function getDivisionsAmbassadorReportExportWatcher(payload) {
  return {
    type: GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_WATCHER,
    payload,
  }
}

export function getMeditionsReportExportSuccess(payload) {
  return {
    type: GET_MEDITIONS_REPORT_EXPORT_SUCCESS,
    payload,
  }
}

// export
export function exportReportWatcher(payload) {
  return {
    type: GET_EXPORT_REPORT_WATCHER,
    payload,
  }
}

export function exportReportSuccess(payload) {
  return {
    type: GET_EXPORT_REPORT_SUCCESS,
    payload,
  }
}

export function exportReportFailed() {
  return { type: GET_EXPORT_REPORT_FAILED }
}
